import React, { useEffect, useState } from "react";
import "./AllProducer.scss";
import ProducerFilter from "../ProducerFilter/ProducerFilter";
import Helpers from "@utils/Helpers";
import { errorLog } from "logging";
import { IProductSearch } from "@utils/Interfaces";
import { Col, Empty, Row, Skeleton } from "antd";
import ProducerItem from "@components/ProducerItem/ProducerItem";
import userApi from "services/UserApi";

const AllProducer: React.FC = () => {
  const [allProducers, setAllProducers] = useState<any>(null);
  const [searchParam, setSearchParam] = useState<IProductSearch>({
    query: "",
    type: null,
    location: null,
    categories_id: [1, 2, 3],
    selling_method: null,
    quantity: null,
    radius: 300,
    address: "",
    filters: {
      hay_cut: [],
      bale_weight_min: 0,
      bale_weight_max: 200,
      shape: [],
      size: [],
      hay_compression: [],
      moisture: [],
      rain: [],
      storage: [],
      crop: [],
      binding_type: [],
      price_min: 0,
      price_max: 1000,
      shipping_options: [],
      payment_options: [],
      crude_protein_range_ids: [],
    },
  });
  const [isOpenMap, setIsOpenMap] = useState(false);
  const [viewMode, setViewMode] = useState("small");

  useEffect(() => {
    const getProducers = async () => {
      try {
        const response = await userApi.getProducers();
        if (response.status === 200) {
          setAllProducers(
            response.data.data.filter(
              (item: any) => item.farm_info.farm_name !== ""
            )
          );
        }
      } catch (error) {
        Helpers.notification.error("Can not fetch producers. Please try again");
        errorLog("Producer.tsx - getProducers", error);
      }
    };
    if (!allProducers) {
      getProducers();
    }
  }, [allProducers]);

  return (
    <div className="AllProducer">
      <div className="container">
        <ProducerFilter
          searchParam={searchParam}
          setSearchParam={setSearchParam}
          setIsOpenMap={setIsOpenMap}
          isOpenMap={isOpenMap}
          componentIn={"productCatalog"}
          viewMode={viewMode}
          setViewMode={setViewMode}
        />
        <div className="section-title-group">
          <div className="section-title">All Producers</div>
        </div>

        <div className="result-wrap">
          <Row gutter={16}>
            <Col span={isOpenMap ? 12 : 24}>
              <div className={`result-group ${isOpenMap ? "map" : ""}`}>
                {allProducers == null ? (
                  <div
                    className={`producer-list ${
                      viewMode === "small"
                        ? isOpenMap
                          ? "producer-list-3"
                          : "producer-list-5"
                        : isOpenMap
                        ? "producer-list-2"
                        : "producer-list-3"
                    }`}
                  >
                    {Array.from({
                      length: 5,
                    }).map((_, index) => {
                      return (
                        <div className="producer-item" key={index}>
                          <div className="producer-placeholder">
                            <Skeleton.Image
                              active={true}
                              className="skeleton-image"
                            />
                            <div className="content">
                              <Skeleton active={true} />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : allProducers && allProducers.length === 0 ? (
                  <Empty
                    className="empty-section"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ) : (
                  <>
                    <div
                      className={`producer-list ${
                        viewMode === "small"
                          ? isOpenMap
                            ? "producer-list-3"
                            : "producer-list-5"
                          : isOpenMap
                          ? "producer-list-2"
                          : "producer-list-3"
                      }`}
                    >
                      {allProducers
                        .slice(0, 15)
                        .map((item: any, index: number) => {
                          return <ProducerItem data={item} key={index} />;
                        })}
                    </div>
                  </>
                )}
              </div>
            </Col>
            {/* {isOpenMap && (
              <Col span={12}>
                <div className="product-map-wrap">
                  <ProductMap
                    productNearBy={allProducers}
                    isProductDetail={false}
                  />
                </div>
              </Col>
            )} */}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AllProducer;
